import React from 'react';
import { Col, Divider, Row } from 'antd';
import Wrapper from './style';
import { INTEGRATOR_FACEBOOK } from '../../configs/integrator';
import { toCurrency } from '../../utils/commonUtils';

const { CAMPAIGN_OBJECTIVE_TYPE } = INTEGRATOR_FACEBOOK();
const { POST_ENGAGEMENT, PAGE_LIKES, EVENT_RESPONSES } =
  CAMPAIGN_OBJECTIVE_TYPE;

const displayValue = (value) => {
  if (value) {
    const text = value.replace(/_/g, ' ');
    const parse = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    return parse;
  }
  return value;
};
const Description = (props) => {
  const { label, value, emptyText = '-', onParseValue } = props;
  let display = value;
  if (onParseValue) {
    display = displayValue(value);
  }

  return (
    <Row gutter={[4, 4]}>
      {label && (
        <Col
          span={24}
          className="font-paragraph_medium black3 description_label"
        >
          {label}
        </Col>
      )}
      <Col
        span={24}
        className={`font-paragraph ${
          value ? 'black1' : 'black4'
        } description_value`}
      >
        {display || emptyText}
      </Col>
    </Row>
  );
};

const Campaign = (props) => {
  const { dataSource } = props;
  const adIntegration = dataSource?.data?.ad_integration || {};
  const campaignData = dataSource?.data?.facebook_campaign || {};

  const currency = adIntegration?.currency || 'IDR';
  const adSetData = dataSource?.data?.facebook_adset || {};
  const onGetCampaignBudget = () => {
    const data = adSetData?.budget_type || campaignData?.budget_type;
    if (!data) return false;
    return `${displayValue(data?.name)} ${
      data?.amount ? ` - ${toCurrency(data?.amount, currency)}` : '-'
    }`;
  };

  const onGetCampaignBid = () => {
    return adSetData?.bid_strategy || campaignData?.bid_strategy;
  };

  const onGetCampaignObjective = () => {
    let objective = campaignData?.objective;
    let subObjective = null;
    const engagementObjectives = [POST_ENGAGEMENT, PAGE_LIKES, EVENT_RESPONSES];
    const isEngagementObjective = engagementObjectives.includes(objective);

    Object.keys(CAMPAIGN_OBJECTIVE_TYPE).forEach((key) => {
      if (CAMPAIGN_OBJECTIVE_TYPE[key] === objective) {
        if (isEngagementObjective) {
          objective = 'Engagement';
          subObjective = key;
        } else {
          objective = key;
        }
      }
    });
    return { objective, subObjective, isEngagementObjective };
  };

  const onGetSpendingCap = () => {
    const spendCap = campaignData?.spend_cap;
    return `${toCurrency(spendCap, currency)}`;
  };

  return (
    <Wrapper>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Description label="Campaign Name" value={campaignData?.name} />
        </Col>
        <Col span={24}>
          <Description
            label="Campaign Spending Limit (Optional)"
            value={onGetSpendingCap()}
          />
        </Col>
        <Col span={24}>
          <Row gutter={16}>
            <Col span={12}>
              <Description
                label="Buying Detail"
                value={campaignData?.buying_type}
                onParseValue
              />
            </Col>
            <Col span={12}>
              <Description
                label="Campaign Objective"
                value={onGetCampaignObjective().objective}
                onParseValue
              />
            </Col>
          </Row>
        </Col>
        {onGetCampaignObjective().isEngagementObjective && (
          <Col span={24}>
            <Description
              label="Engagement Type"
              value={onGetCampaignObjective().subObjective}
              onParseValue
            />
          </Col>
        )}
        <Col span={24}>
          <Divider style={{ margin: 0 }} />
        </Col>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Row gutter={[12, 12]}>
                <Col span={24} className="font-subtitle2_medium black1">
                  Campaign Budget Optimazion
                </Col>
                <Col span={24} className="font-paragraph black2">
                  Campaign budget optimization will distribute your budget
                  across ad sets to get more results depending on your delivery
                  optimization choices and bid strategy. You can control
                  spending on each ad set.
                </Col>
              </Row>
            </Col>

            <Col span={24}>
              <Row gutter={16}>
                <Col span={12}>
                  <Description
                    label="Campaign Bid Strategy"
                    value={onGetCampaignBid()}
                    onParseValue
                  />
                </Col>
                <Col span={12}>
                  <Description
                    label="Campaign Budget"
                    value={onGetCampaignBudget()}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        {campaignData?.ab_test && (
          <>
            <Col span={24}>
              <Divider style={{ margin: 0 }} />
            </Col>
            <Col span={24}>
              <Row gutter={[12, 12]}>
                <Col span={24} className="font-subtitle2_medium black1">
                  A/B Test
                </Col>
                <Col span={24} className="font-paragraph black4">
                  Test campaigns, ad sets and ads against each other to
                  understand which strategies give you the best results. Your
                  potential reach will be divided among them for more accurate
                  results.
                </Col>
              </Row>
            </Col>
          </>
        )}
      </Row>
    </Wrapper>
  );
};

export default Campaign;
